module.exports = __webpack_public_path__ + "static/media/profile-picture.41f0c319.jpg";